import React from 'react';

import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import styles from 'css-module/components/www/_LandingHowItWorks.module.scss';
import UseCases1 from 'img/landing/use-cases-1.webp';
import UseCases2 from 'img/landing/use-cases-4.webp';
import UseCases6 from 'img/landing/use-cases-6.webp';

import Megaphone from 'img/icons/megaphone.png';

type Props = {
  title?: React.ReactNode | string;
  plain?: boolean;
};

const LandingHowItWorks = ({
  title = <>Your complete customer feedback&nbsp;platform</>,
  plain = false,
}: Props) => {
  return (
    <div className={`${styles.howItWorks} ${plain ? styles.plain : ''}`}>
      <h2 className={styles.header}>{title}</h2>
      <div className={styles.steps}>
        <Link to="/features/collect-feedback" className={styles.step}>
          <LazyLoadedImage
            className={styles.image}
            alt="Collect customer feedback"
            loading="eager"
            src={UseCases1}
          />
          <div className={styles.text}>
            <div className={styles.title}>Capture product&nbsp;feedback</div>
            <div className={styles.description}>
              All in one place so nothing slips through the&nbsp;cracks
            </div>
          </div>
        </Link>
        <div className={`${styles.rightChevron} icon-chevron-right`} />
        <Link to="/features/analyze-feedback" className={styles.step}>
          <LazyLoadedImage
            className={styles.image}
            alt="Analyze customer feedback"
            loading="eager"
            src={UseCases2}
          />
          <div className={styles.text}>
            <div className={styles.title}>Inform product&nbsp;decisions</div>
            <div className={styles.description}>
              Analyze feedback to see what's most&nbsp;impactful
            </div>
          </div>
        </Link>
        <div className={`${styles.rightChevron} icon-chevron-right`} />
        <Link to="/features/product-roadmap" className={styles.step}>
          <LazyLoadedImage
            className={styles.image}
            alt="Priorization and product roadmapping"
            loading="eager"
            src={UseCases6}
          />
          <div className={styles.text}>
            <div className={styles.title}>Prioritize and&nbsp;roadmap</div>
            <div className={styles.description}>
              Rank features by priority and build a product&nbsp;roadmap
            </div>
          </div>
        </Link>
        <div className={`${styles.rightChevron} icon-chevron-right`} />
        <Link to="/features/product-changelog" className={styles.step}>
          <LazyLoadedImage
            className={styles.image}
            alt="Product changelog"
            loading="eager"
            src={Megaphone}
          />
          <div className={styles.text}>
            <div className={styles.title}>Announce product&nbsp;updates</div>
            <div className={styles.description}>Engage everyone with your newest&nbsp;features</div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default LandingHowItWorks;
